import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { Dropdown } from 'components/layout/form-fields/inputs/Dropdown';
import { jobVacancyStore } from '../JobVacancyStore';
import { FormField } from 'components/layout/form-fields/FormField';

const ValidationSchema = Yup.object().shape({
	cancelReason: Yup.string()
		.label('Reason')
		.nullable()
		.when('status', {
			is: 'cancelled',
			then: schema => schema.required()
		}),
	notes: Yup.string()
		.label('Notes')
		.when('status', {
			is: 'cancelled',
			then: schema => schema.required()
		})
});

export class JobVacancyEdit extends ModalComponent {
	getInitialValues() {
		return {
			notes: this.props.vacancy.notes || '',
			cancelReason: this.props.vacancy.cancelReason
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'JobVacancyEdit')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				{['cancelled', 'on_hold'].includes(formikBag.values.status) ? (
					<div className="columns">
						<div className="column is-full">
							<div className="field has-text-left">
								<label className="subtitle is-7">Reason</label>
								<div className="control">
									<Dropdown
										enableFixedMode={true}
										value={formikBag.values.cancelReason}
										onValueChange={item => {
											formikBag.setFieldValue('cancelReason', item);
										}}
										options={jobVacancyStore.cancelReasonOptions}
										optionValue={'value'}
									/>
								</div>
							</div>
						</div>
					</div>
				) : null}
				<div className="columns">
					<div className="column is-full">
						<FormField
							className="has-text-left"
							label="Comments"
							field="notes"
							type="textarea"
							placeholder="Comments"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	async create(values) {
		jobVacancyStore
			.update(this.props.vacancy.id, {
				jobVacancy: {
					notes: values.notes,
					cancelReason: values.cancelReason
				}
			})
			.then(result => {
				this.resultNotification(result, 'Vacancy Status', 'Update');
			});
	}
}
